"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.timers.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _uploadFile = require("./uploadFile");
var _injectValue = require("../_utils/injectValue");
var _isCallable = require("../_utils/isCallable");
var _UploadContext = require("./UploadContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { uuid } from '../_utils/uuid';

// 判断当前变量是否是 promise
function isPromise(p) {
  return p && (0, _typeof2.default)(p) === 'object' && typeof p.then === 'function';
}

// 上传组件
var Upload = function Upload(props) {
  var _props$action = props.action,
    action = _props$action === void 0 ? '' : _props$action,
    accept = props.accept,
    maxSize = props.maxSize,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$directory = props.directory,
    directory = _props$directory === void 0 ? false : _props$directory,
    headers = props.headers,
    data = props.data,
    _props$name = props.name,
    name = _props$name === void 0 ? 'file' : _props$name,
    withCredentials = props.withCredentials,
    _props$beforeUpload = props.beforeUpload,
    beforeUpload = _props$beforeUpload === void 0 ? function (_, __, isAccepted) {
      return isAccepted;
    } : _props$beforeUpload,
    _props$onStart = props.onStart,
    onStart = _props$onStart === void 0 ? function () {
      return null;
    } : _props$onStart,
    onProgress = props.onProgress,
    onSuccess = props.onSuccess,
    onError = props.onError,
    children = props.children,
    className = props.className,
    style = props.style;
  var isMultiple = multiple;
  if (directory) {
    // eslint-disable-next-line no-param-reassign
    isMultiple = true;
  }
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dragging = _useState2[0],
    setDragging = _useState2[1];
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      accept: accept,
      maxSize: maxSize,
      multiple: isMultiple,
      noClick: true,
      noKeyboard: true,
      onDrop: uploadFiles,
      onDragEnter: function onDragEnter() {
        return setDragging(true);
      },
      onDragLeave: function onDragLeave() {
        return setDragging(false);
      }
    }),
    getInputProps = _useDropzone.getInputProps,
    getRootProps = _useDropzone.getRootProps,
    open = _useDropzone.open;
  function uploadFiles() {
    var acceptedFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var fileRejections = arguments.length > 1 ? arguments[1] : undefined;
    var rejectedFiles = fileRejections.map(function (r) {
      return r.file;
    });
    var fileList = [].concat((0, _toConsumableArray2.default)(acceptedFiles), (0, _toConsumableArray2.default)(rejectedFiles));
    acceptedFiles.forEach(function (file) {
      // file.id = uuid();  // eslint-disable-line no-param-reassign
      uploadFile(file, fileList, true);
    });
    fileRejections.forEach(function (_ref) {
      var file = _ref.file,
        errors = _ref.errors;
      // file.id = uuid(); // eslint-disable-line no-param-reassign
      uploadFile(file, fileList, false, errors);
    });
    setDragging(false);
  }
  function uploadFile(file, fileList, isAccepted) {
    var reasons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var couldUpload = beforeUpload(file, fileList, isAccepted, reasons);
    if (isPromise(couldUpload)) {
      couldUpload.then(function () {
        return request(file);
      }).catch(function () {
        return null;
      });
    } else {
      if (!couldUpload) {
        return;
      }
      setTimeout(function () {
        return request(file);
      }, 0);
    }
  }
  function request(_x) {
    return _request.apply(this, arguments);
  }
  function _request() {
    _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(file) {
      var uploadAction, xhr;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof action === 'function')) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return action(file);
          case 3:
            uploadAction = _context.sent;
            _context.next = 7;
            break;
          case 6:
            uploadAction = action;
          case 7:
            xhr = (0, _uploadFile.upload)({
              action: uploadAction,
              filename: name,
              file: file,
              data: (0, _injectValue.injectValue)(data)(file),
              headers: (0, _injectValue.injectValue)(headers)(file),
              withCredentials: withCredentials,
              onProgress: onProgress,
              onSuccess: onSuccess,
              onError: onError
            });
            onStart(file, {
              xhr: xhr
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _request.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(_UploadContext.UploadContext.Provider, {
    value: {
      open: open,
      getDraggerProps: getRootProps,
      isDragging: dragging
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    style: style
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, getInputProps(), {
    directory: directory ? 'directory' : undefined,
    webkitdirectory: directory ? 'webkitdirectory' : undefined
  })), (0, _isCallable.isCallable)(children) ? children({
    open: open,
    getDraggerProps: getRootProps,
    isDragging: dragging
  }) : /*#__PURE__*/_react.default.createElement("span", {
    onClick: open
  }, children)));
};
var _default = exports.default = Upload;